import { render, staticRenderFns } from "./PesquisaAtoInfralegalMunicipalShow.vue?vue&type=template&id=1017ab5e&scoped=true"
import script from "./PesquisaAtoInfralegalMunicipalShow.vue?vue&type=script&lang=js"
export * from "./PesquisaAtoInfralegalMunicipalShow.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAtoInfralegalMunicipalShow.vue?vue&type=style&index=0&id=1017ab5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1017ab5e",
  null
  
)

export default component.exports